import '../../css/Leader.css';
import ExportIcon from "../icons/ExportIcon";
import {getStatusForDetailReq} from "../methods/TransactionStatusName";

export default function HeaderOfLeaderPortal({title, text, exportFunction}) {
    return(
        <div className={`row w-100 justify-content-between`}>

            <div className={`col p-0`}>
                <p className={`leader_header_title`}>{title}</p>
                <p className={`leader_header_text`}>{text}</p>
            </div>

            {/* {exportFunction &&
                <div className={`col-2 d-flex align-items-center ltr p-0`}>
                    <div className={`d-flex leader-logout pointer rtl`} style={{padding: "4.5%"}} onClick={exportFunction}>
                        <ExportIcon/>
                        <span className={`me-2`}>خروجی excel</span>
                    </div>
                </div>
            } */}

        </div>
    )
}

export const HeaderOfDetail = ({title, text, traceId, status, cert, certType}) => {

    return(
        <div className={`row w-100 justify-content-between`}>

            <div className={`col p-0`}>
                <p className={`leader_header_title`}>{title}</p>
                <p className={`leader_header_text`}>{text}</p>
            </div>

            {traceId &&
                <div className={`col-3 d-flex align-items-center ltr p-0`}>
                    <div className={`d-flex leader-logout rtl`} style={{padding: "4.5%", fontWeight: "600"}}>
                        <span style={{fontWeight: "700"}}> کد پیگیری : </span>
                        &nbsp;
                        &nbsp;
                        {traceId}
                    </div>
                </div>
            }

            {
                status &&
                <div className={`col-12 d-flex align-items-center p-0`}>
                    <div className={`leader-status-trans`}>
                        <span style={{fontWeight: "700"}}> وضعیت صدور گواهی : </span>
                        &nbsp;
                        &nbsp;
                        {getStatusForDetailReq(status, cert, certType)}
                    </div>
                </div>
            }

        </div>
    )
}
